import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import CustomButton from '../../../../../../../../../lib/designSystem/Button';

interface NullmentGlossDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (gloss: string) => void;
  selectedCount: number;
}

const NullmentGlossDialog: React.FC<NullmentGlossDialogProps> = ({
  open,
  onClose,
  onConfirm,
  selectedCount,
}) => {
  const [gloss, setGloss] = useState('');

  const handleConfirm = () => {
    if (gloss.trim()) {
      onConfirm(gloss.trim());
      setGloss('');
    }
  };

  const handleClose = () => {
    setGloss('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div">
          Anular Documentos
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Has seleccionado <strong>{selectedCount}</strong>{' '}
            {selectedCount === 1 ? 'documento' : 'documentos'} para anular.
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Por favor, ingresa la glosa de anulación que se utilizará para{' '}
            {selectedCount === 1 ? 'este documento' : 'estos documentos'}:
          </Typography>

          <TextField
            fullWidth
            label="Glosa de anulación"
            value={gloss}
            onChange={(e) => setGloss(e.target.value)}
            placeholder="Ej: Error en la facturación"
            variant="outlined"
            multiline
            rows={3}
            autoFocus
            helperText="Esta glosa aparecerá en el documento de anulación"
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <CustomButton color="secondary" onClick={handleClose}>
          Cancelar
        </CustomButton>
        <CustomButton
          color="primary"
          onClick={handleConfirm}
          disabled={!gloss.trim()}
        >
          Continuar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default NullmentGlossDialog;

